// extracted by mini-css-extract-plugin
export default {"root":"video_catalog_root__v1Fu1","hiddenDiv":"video_catalog_hiddenDiv__0qMzd"};